import { useSelector } from 'react-redux';
import { useRestaurant } from '../contexts/RestaurantContext.jsx';
import { selectAppSettings } from '../app/appSettingsSlice.js';
import { getThemeColor } from '../utils/themeUtils';

/**
 * Custom hook to get the current theme color from Redux state (restaurant-scoped).
 * Must be used inside RestaurantProvider.
 * @returns {string} The current theme color hex code
 */
const useThemeColor = () => {
  const { restaurantSlug } = useRestaurant();
  const appTheme = useSelector((state) =>
    selectAppSettings(state, restaurantSlug).appTheme
  );
  return getThemeColor(appTheme);
};

export default useThemeColor;

